"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _underscore = require("underscore");

var _GoodFiltersAndPage = _interopRequireDefault(require("../../constants/GoodFiltersAndPage"));

var _HubspotUrls = _interopRequireDefault(require("../../constants/HubspotUrls"));

var _InitialFilterParams = _interopRequireDefault(require("../../constants/InitialFilterParams"));

var _utils = require("../../utils/utils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router/UIRouterLink"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIDescriptionList = _interopRequireDefault(require("UIComponents/list/UIDescriptionList"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _PackCounts = _interopRequireDefault(require("marketplace-lib/components/goods/PackCounts"));

var _withPartials = _interopRequireDefault(require("marketplace-lib/components/hocs/withPartials"));

var _ModuleCompatibilityTagsList = _interopRequireDefault(require("marketplace-lib/components/list/ModuleCompatibilityTagsList"));

var _ModuleFunctionTagsList = _interopRequireDefault(require("marketplace-lib/components/list/ModuleFunctionTagsList"));

var _CertificationBadges = _interopRequireDefault(require("../CertificationBadges"));

var _FilterRouterLink = _interopRequireDefault(require("../FilterRouterLink"));

var _Object$freeze;

var getI18nKey = (0, _underscore.memoize)(function (path) {
  return "MarketplaceUI.goodDetailsPage.info." + path;
});
var getTagI18nKey = (0, _underscore.memoize)(function (tagType, tagName) {
  return "tagNames." + tagType + "." + tagName;
}, function (tagType, tagName) {
  return tagType + "-" + tagName;
});
var GoodTagKeys = Object.freeze((_Object$freeze = {}, (0, _defineProperty2.default)(_Object$freeze, _GoodFiltersAndPage.default.MODULE_PURPOSE, 'customModulePurposeTag'), (0, _defineProperty2.default)(_Object$freeze, _GoodFiltersAndPage.default.MODULE_COMPATIBILITY, 'customModuleCompatibilityTag'), (0, _defineProperty2.default)(_Object$freeze, _GoodFiltersAndPage.default.FEATURES, 'featureTags'), (0, _defineProperty2.default)(_Object$freeze, _GoodFiltersAndPage.default.INDUSTRY, 'industryTag'), (0, _defineProperty2.default)(_Object$freeze, _GoodFiltersAndPage.default.PAGE_LAYOUT, 'layoutTag'), (0, _defineProperty2.default)(_Object$freeze, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, 'templatePurposeTag'), (0, _defineProperty2.default)(_Object$freeze, _GoodFiltersAndPage.default.CODING_TYPE, 'codingType'), _Object$freeze));

var GoodInfoCard =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(GoodInfoCard, _PureComponent);

  function GoodInfoCard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GoodInfoCard);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoodInfoCard).call(this, props));
    _this.renderFilterLink = _this.renderFilterLink.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderMultiselectFilterLink = _this.renderMultiselectFilterLink.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(GoodInfoCard, [{
    key: "renderFilterLink",
    value: function renderFilterLink(filters, linkText) {
      var _this$props = this.props,
          defaultFilters = _this$props.defaultFilters,
          previewMode = _this$props.previewMode;
      return _react.default.createElement(_FilterRouterLink.default, {
        key: JSON.stringify(filters),
        disabled: previewMode,
        filters: defaultFilters.merge(filters)
      }, linkText);
    }
  }, {
    key: "renderMultiselectFilterLink",
    value: function renderMultiselectFilterLink(filterType, _ref) {
      var tag = _ref.tag,
          tagTitle = _ref.tagTitle;
      var filters = (0, _defineProperty2.default)({}, filterType, [tag]);
      return this.renderFilterLink(filters, tagTitle);
    }
  }, {
    key: "renderProductType",
    value: function renderProductType() {
      var goodDetails = this.props.goodDetails;
      var filter = (0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.SUB_TYPE, goodDetails.get('subType'));
      return [_react.default.createElement("dt", {
        key: "product-type-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('productType.title')
      })), _react.default.createElement("dd", {
        key: "product-type-description"
      }, this.renderFilterLink(filter, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey("productType.types." + goodDetails.get('subType'))
      })))];
    }
  }, {
    key: "renderDownloadsCount",
    value: function renderDownloadsCount() {
      var goodDetails = this.props.goodDetails;
      return [_react.default.createElement("dt", {
        key: "downloads-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey("downloads.title." + (goodDetails.get('isFree') ? 'installed' : 'purchased'))
      })), _react.default.createElement("dd", {
        key: "downloads-description"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('downloads.count'),
        options: {
          count: goodDetails.get('downloads')
        }
      }))];
    }
  }, {
    key: "renderModuleFunctionTags",
    value: function renderModuleFunctionTags() {
      var _this$props2 = this.props,
          goodDetails = _this$props2.goodDetails,
          partial = _this$props2.partial;
      var tagKey = GoodTagKeys[_GoodFiltersAndPage.default.MODULE_PURPOSE];
      var moduleFunctionTags = goodDetails.get(tagKey);

      if (!moduleFunctionTags.size) {
        return null;
      }

      return [_react.default.createElement("dt", {
        key: tagKey + "-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey(tagKey + ".title")
      })), _react.default.createElement("dd", {
        key: tagKey + "-description"
      }, _react.default.createElement(_ModuleFunctionTagsList.default, {
        moduleFunctions: moduleFunctionTags.toArray(),
        tagComponent: partial(this.renderMultiselectFilterLink, _GoodFiltersAndPage.default.MODULE_PURPOSE)
      }))];
    }
  }, {
    key: "renderModuleCompatibility",
    value: function renderModuleCompatibility() {
      var _this$props3 = this.props,
          goodDetails = _this$props3.goodDetails,
          partial = _this$props3.partial;
      var tagKey = GoodTagKeys[_GoodFiltersAndPage.default.MODULE_COMPATIBILITY];
      var moduleCompatibilityTags = goodDetails.get(tagKey);

      if (!moduleCompatibilityTags.size) {
        return null;
      }

      return [_react.default.createElement("dt", {
        key: tagKey + "-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey(tagKey + ".title")
      })), _react.default.createElement("dd", {
        key: tagKey + "-description"
      }, _react.default.createElement(_ModuleCompatibilityTagsList.default, {
        moduleCompatibility: moduleCompatibilityTags.toArray(),
        tagComponent: partial(this.renderMultiselectFilterLink, _GoodFiltersAndPage.default.MODULE_COMPATIBILITY)
      }))];
    }
  }, {
    key: "renderParents",
    value: function renderParents() {
      var goodDetails = this.props.goodDetails;
      var parents = goodDetails.get('parents');

      if (!parents.size) {
        return null;
      }

      return [_react.default.createElement("dt", {
        key: "parents-title"
      }, _react.default.createElement(_UIHelpIcon.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('parents.help')
        })
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('parents.title')
      }))), _react.default.createElement("dd", {
        key: "parents-description"
      }, _react.default.createElement(_UIList.default, null, parents.map(function (parent) {
        return _react.default.createElement(_UIRouterLink.default, {
          key: parent.get('urlToken'),
          to: "products/" + parent.get('urlToken')
        }, (0, _utils.getEnglishTextFieldFromTextsMap)('NAME', parent.get('goodText')));
      })))];
    }
  }, {
    key: "renderPackCounts",
    value: function renderPackCounts() {
      var goodDetails = this.props.goodDetails;
      return [_react.default.createElement("dt", {
        key: "pack-counts-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('packCounts.title'),
        options: {
          count: goodDetails.get('totalChildren')
        }
      })), _react.default.createElement("dd", {
        key: "pack-counts-description"
      }, _react.default.createElement(_PackCounts.default, {
        packCounts: goodDetails.get('packCounts'),
        showHeader: false
      }))];
    }
  }, {
    key: "renderTags",
    value: function renderTags(filterType) {
      var _this2 = this;

      var multi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var goodDetails = this.props.goodDetails;
      var tagKey = GoodTagKeys[filterType];
      var tags = goodDetails.get(tagKey);

      if (!tags.size) {
        return null;
      }

      var tagsToRender = multi ? tags : [tags.get(0)];
      return [_react.default.createElement("dt", {
        key: tagKey + "-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey(tagKey + ".title")
      })), _react.default.createElement("dd", {
        key: tagKey + "-description"
      }, _react.default.createElement(_UIList.default, null, tagsToRender.map(function (tag) {
        var tagFilter = (0, _defineProperty2.default)({}, filterType, multi ? [tag] : tag);
        return _this2.renderFilterLink(tagFilter, _react.default.createElement(_FormattedMessage.default, {
          message: getTagI18nKey(tagKey, tag)
        }));
      })))];
    }
  }, {
    key: "renderDocumentationLink",
    value: function renderDocumentationLink() {
      var _this$props4 = this.props,
          goodDetails = _this$props4.goodDetails,
          previewMode = _this$props4.previewMode,
          trackLinkClick = _this$props4.trackLinkClick,
          partial = _this$props4.partial;
      var documentationLink = goodDetails.get('documentationLink');
      return documentationLink && _react.default.createElement(_UILink.default, {
        key: "documentation-link",
        disabled: previewMode,
        external: true,
        href: documentationLink,
        onClick: partial(trackLinkClick, 'documentation')
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('resources.links.documentation')
      }));
    }
  }, {
    key: "renderResourceLinks",
    value: function renderResourceLinks() {
      var renderedResourceLinks = [this.renderDocumentationLink()].filter(Boolean);

      if (!renderedResourceLinks.length) {
        return null;
      }

      return renderedResourceLinks.length && [_react.default.createElement("dt", {
        key: "resources-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('resources.title')
      })), _react.default.createElement("dd", {
        key: "resources-description"
      }, _react.default.createElement(_UIList.default, null, renderedResourceLinks))];
    }
  }, {
    key: "renderProviderInfo",
    value: function renderProviderInfo() {
      var _this$props5 = this.props,
          goodDetails = _this$props5.goodDetails,
          previewMode = _this$props5.previewMode,
          trackLinkClick = _this$props5.trackLinkClick,
          partial = _this$props5.partial;
      var contactEmail = goodDetails.get('contactEmail');
      var contactLink = null;

      if (contactEmail) {
        contactLink = _EmailAddress.default.test(contactEmail) ? "mailto:" + contactEmail : contactEmail;
      }

      return [_react.default.createElement("dt", {
        key: "provider-info-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('provider.title')
      })), _react.default.createElement("dd", {
        key: "provider-info-description"
      }, _react.default.createElement(_UIList.default, null, goodDetails.get('providerName'), _react.default.createElement(_FilterRouterLink.default, {
        disabled: previewMode,
        filters: _InitialFilterParams.default.merge((0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.PROVIDER, goodDetails.get('providerName')))
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('provider.links.products')
      })), _react.default.createElement(_UILink.default, {
        disabled: previewMode,
        external: true,
        href: goodDetails.get('providerWebsite'),
        onClick: partial(trackLinkClick, 'providerWebsite')
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('provider.links.website')
      })), contactLink && _react.default.createElement(_UILink.default, {
        disabled: previewMode,
        external: true,
        href: contactLink,
        onClick: partial(trackLinkClick, 'email')
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('provider.links.email')
      }))))];
    }
  }, {
    key: "renderCertifications",
    value: function renderCertifications() {
      var _this$props6 = this.props,
          goodDetails = _this$props6.goodDetails,
          previewMode = _this$props6.previewMode,
          trackLinkClick = _this$props6.trackLinkClick,
          partial = _this$props6.partial;
      var certifications = goodDetails.get('certifications');
      return [_react.default.createElement("dt", {
        key: "certifications-title"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('certifications.title')
      })), _react.default.createElement("dd", {
        key: "certifications-description"
      }, _react.default.createElement(_CertificationBadges.default, {
        certifications: certifications
      }), _react.default.createElement(_UILink.default, {
        disabled: previewMode,
        external: true,
        href: _HubspotUrls.default.CERTIFICATION_OVERVIEW,
        onClick: partial(trackLinkClick, 'certifications')
      }, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('learnMore')
      })))];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          isCustomModule = _this$props7.isCustomModule,
          isEmailTemplate = _this$props7.isEmailTemplate,
          isPack = _this$props7.isPack,
          isTemplate = _this$props7.isTemplate;
      return _react.default.createElement(_UICardWrapper.default, {
        className: "m-bottom-0",
        compact: true
      }, _react.default.createElement(_UICardSection.default, null, _react.default.createElement(_UIDescriptionList.default, null, this.renderProductType(), this.renderDownloadsCount(), isCustomModule && this.renderModuleFunctionTags(), isCustomModule && this.renderModuleCompatibility(), this.renderParents(), isPack && this.renderPackCounts(), this.renderTags(_GoodFiltersAndPage.default.FEATURES), this.renderTags(_GoodFiltersAndPage.default.INDUSTRY, false), isTemplate && this.renderTags(_GoodFiltersAndPage.default.PAGE_LAYOUT, false), isTemplate && this.renderTags(_GoodFiltersAndPage.default.TEMPLATE_PURPOSE, false), isEmailTemplate && this.renderTags(_GoodFiltersAndPage.default.CODING_TYPE), this.renderResourceLinks(), _react.default.createElement(_HR.default, null), this.renderProviderInfo(), this.renderCertifications())));
    }
  }]);
  return GoodInfoCard;
}(_react.PureComponent);

GoodInfoCard.propTypes = {
  defaultFilters: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  goodDetails: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  isCustomModule: _propTypes.default.bool.isRequired,
  isEmailTemplate: _propTypes.default.bool.isRequired,
  isPack: _propTypes.default.bool.isRequired,
  isTemplate: _propTypes.default.bool.isRequired,
  partial: _propTypes.default.func.isRequired,
  previewMode: _propTypes.default.bool.isRequired,
  trackLinkClick: _propTypes.default.func.isRequired
};
GoodInfoCard.defaultProps = {
  defaultFilters: _immutable.default.Map()
};

var _default = (0, _withPartials.default)(GoodInfoCard);

exports.default = _default;
module.exports = exports.default;